import { useState, ReactNode, FC } from 'react';
import { Input } from '@dynamika-shared/ui/Input/Input';
import { EditIcon } from '@dynamika-shared/ui/icons';
import { Button } from '@dynamika-shared/ui/Button/Button';

type EditableFieldProps = {
  name: string;
  value: string;
  placeholder?: string;
  errors?: string;
  onChange: (value: string) => void;
  children?: ReactNode;
}

export const EditableField: FC<EditableFieldProps> = ({
  name,
  value,
  placeholder,
  errors,
  onChange,
  children,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div>
      {isEditing ? (
        <Input
          autoFocus
          data-testid={name}
          placeholder={placeholder}
          name={name}
          value={value}
          status={errors ? 'error' : ''}
          onChange={e => onChange(e.target.value)}
          onBlur={() => setIsEditing(false)}
        />
      ) : (
        <div className={'flex items-center gap-1'}>
          {children || <span>{value || 'Click to edit'}</span>}
          <Button onClick={() => setIsEditing(true)} type={'text'}>
            <EditIcon color={'dimGray'} width={14} />
          </Button>
        </div>
      )}
    </div>
  );
};
